class BannerPopup {

    constructor() {
        this.icon = document.querySelector('.ww-products__banner__info__icon');
        this.text = document.querySelector('.ww-products__banner__info__text');
        this.iconImg = document.querySelector('.ww-products__banner__info__img');
        if (this.icon) {
            this.events();
        }
    }

    events() {
        this.icon.addEventListener("click", () => this.show());
        this.icon.addEventListener("mouseover", () => this.show());
        this.icon.addEventListener("mouseout", () => this.hide());
        // Close the popup if the user clicks outside of filter menu it
        window.addEventListener("click", event => {
            if ( !event.target.matches( '.' + this.iconImg.className ) ) {
                this.hide();
            } 
        });
    }

    show() {
        this.text.classList.toggle('ww-products__banner__info__text--show');
    }
    hide() {
        this.text.classList.remove('ww-products__banner__info__text--show');
    }
    
}

export default BannerPopup